/* Legacy "Our Food" page slider, ported from the old theme.
   Runs after DOMContentLoaded so the layout's deferred jQuery and Slick
   (apa-jquery.min.js, apa-slick.min.js) are guaranteed to have executed. */
(function () {
  function init() {
    if (!window.jQuery || !window.jQuery.fn || typeof window.jQuery.fn.slick !== 'function') return;
    var $ = window.jQuery;
    var $sliders = $('.Page_our_food_product_all_slider').not('.slick-initialized');
    if (!$sliders.length) return;
    $sliders.slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      arrows: true,
      dots:false,
      infinite: false,
      centerMode: false,
      prevArrow:'<button type="button" class="slick-prev" aria-label="Previous slide"><svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="30" cy="30" r="28.5" transform="rotate(-180 30 30)" fill="#0C3D37" stroke="white" stroke-width="3"/><path d="M35 40L25 30L35 20" stroke="white" stroke-width="3"/></svg></button>',
      nextArrow:'<button type="button" class="slick-next" aria-label="Next slide"><svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="30" cy="30" r="28.5" fill="#0C3D37" stroke="white" stroke-width="3"/><path d="M25 20L35 30L25 40" stroke="white" stroke-width="3"/></svg></button>',
      responsive: [
        {
          breakpoint: 750,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            rows: 2,
          }
        }
      ]
    });
  }
  // This file is deferred from the section, so it runs before the layout's
  // deferred jQuery/Slick (readyState is already 'interactive' by then).
  // Wait for DOMContentLoaded, which fires after every deferred script.
  if (document.readyState === 'complete') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
    window.addEventListener('load', init);
  }
  document.addEventListener('shopify:section:load', init);
})();
